import styled, { css } from "styled-components";
import { SectionWrapper } from "shared/Styles/Wrappers";
import ArrowImg from "assets/images/arr_right_p.svg";
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";

export const Container = styled.div`
  background-color: ${({ color }) => (color ? color : "#f9f9f9")};
  color: ${({ color, theme }) => (color ? "#fff" : theme.colors.black)};
  position: sticky;
  top: 60px;
  z-index: 3;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    top: 48px;
  }
`;

export const Wrapper = styled(SectionWrapper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 18px 24px;
  }
`;

export const Icon = styled.div`
  width: 18px;
  height: 18px;
  background-image: url(${ArrowImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-right: 12px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: 14px;
    height: 12px;
  }
`;

export const Text = styled.span`
  font-weight: 600;
  font-size: 1.6rem;
  transition: 0.2s color ease;
  &:hover {
    color: ${({ theme }) => theme.colors.purple};
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 1.4rem;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.2rem;
  }
`;

const defaultLink = css`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  &.disable {
    pointer-events: none;
    opacity: 0.3;
  }
  &.next {
    flex-direction: row-reverse;
    ${Icon} {
      transform: rotate(180deg);
      margin-right: 0px;
      margin-left: 12px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    &.prev,
    &.next {
      ${Text} {
        display: none;
      }
    }
  }
`;

export const StyledLink = styled(Link)`
  ${defaultLink}
`;

export const StyledAnchorLink = styled(AnchorLink)`
  ${defaultLink}
`;
